module.exports = __webpack_public_path__ + "static/media/iinst.b58c674e.jpg";